import { isEmail } from "../utils/index.js";
const calloutComponentInputEmailValidator = (_schema, answer) => {
  return isEmail(answer);
};
export {
  calloutComponentInputEmailValidator
};
